import { TFunction } from "i18next";

import { MessageTemplateActions } from "../../../../../../../types/MessageTemplateEnums";
import smsStatusColors from "../../data/smsStatusColors";

import type { Order } from "../../../../../../../services";

const cellProcessing = (
	item?: Order.Model["smsMessages"],
	type?: MessageTemplateActions,
	t?: TFunction,
) => {
	const smsMessageStatus = item?.find(
		(sms) => sms?.action?.toString() === type?.toString(),
	);

	const status = smsMessageStatus?.status ?? "";

	const content =
		t && smsMessageStatus?.status
			? t(`order_sms_message_statuses.${status}`) ?? ""
			: "";
	const backgroundColor = smsMessageStatus
		? smsStatusColors[status]
		: undefined;

	return { content, backgroundColor };
};

export default cellProcessing;
